import { Injectable } from '@angular/core';

const SecureStorage = require('secure-web-storage');
const CryptoJS = require('crypto-js');

@Injectable({
  providedIn: 'root',
})
export class SecureStorageService {
  public secureStorage = new SecureStorage(localStorage, {
    hash: function hash(key) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      const userKey = currentUser?.userId.toString();
      key = CryptoJS.SHA256(key, userKey);
      return key.toString();
    },
    encrypt: function encrypt(data) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      const userKey = currentUser?.userId.toString();
      data = CryptoJS.AES.encrypt(data, userKey);
      data = data.toString();
      return data;
    },
    decrypt: function decrypt(data) {
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      const userKey = currentUser?.userId.toString();
      data = CryptoJS.AES.decrypt(data, userKey);
      data = data.toString(CryptoJS.enc.Utf8);
      return data;
    },
  });
}

